import { useState,useRef } from "react";
import InnerLayout from "../../components/layouts/inner-layout";
import { Formik } from "formik";
import LoadingOverlay from "../../components/helper-components/overlay-loading";
import successToast from "../../components/helper-components/success-toast";
import errorToast from "../../components/helper-components/error-toast";
import NavBar from "../../components/admin-customer/navBar";
import FlowDetails from "./approval-flow-details";
import Originator from "./originator";
import OriginatorTable from "./originator";
import * as Yup from "yup";
import ApprovalProcedure from "./document-and-terms";
import DocumentSection from "./document-and-terms";
import ApprovalStages from "./approval-stages";
import FlowPreview from "./flow-preview";
import { useNavigate } from "react-router-dom";
import { addApprovalWorkFlowAction, addDocumentsAction, addOriginatorsAction, addStagesAction } from "../../redux/actions/approval-work-flow-action";
import { useDispatch } from "react-redux";
const ApprovalWorkFlow = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const formikRef = useRef(null);
  function syncOriginatorIds(formik, apiData) {
    function toUsersKey(arr) {
      if (!Array.isArray(arr)) return "";
      return Array.from(new Set(arr)).sort().join("|");
    }
    const lookup = new Map();
    (apiData || []).forEach((item) => {
      const key = `${item.department}::${item.role}::${toUsersKey(item.user_ids)}`;
      lookup.set(key, item);
    });

    const originators = (formik.values && formik.values.originators) || [];
    originators.forEach((o, i) => {
      const key = `${o.department}::${o.role}::${toUsersKey(o.users)}`;
      const match = lookup.get(key);
      formik.setFieldValue(`originators[${i}].originator_id`, match ? match.originator_id : null, false);
    });
  }
  function convertStagesData(input) {
    return {
      stages: input.map((item) => {
        const timeline_days = parseInt(item.timeline.match(/\d+/)?.[0] || 0, 10);
        const actions = Object.entries(item.actions)
          .filter(([_, value]) => value)
          .map(([key]) => key.charAt(0).toUpperCase() + key.slice(1));
        return {
          role: item.roleObj?.label || item.role,
          timeline_days,
          user_ids: item.users.map((u) => (isNaN(u.value) ? u.value : Number(u.value))),
          actions,
        };
      }),
    };
  }


  const [initialValues, setInitialValues] = useState({
    flow_name: "",
    is_active: true,
    description: "",
    documentCategory: "",
    documentType: "",
    isAlways: "",
    isRule: "",
    conditions: [],
    originators: [{ departmentObj: null, department: "" }],
    approvalStages: [],
  });

  const validationSchema = Yup.object().shape({
    flow_name: Yup.string().required("Name is required"),
  });
  const [isLoading,setisLoading]=useState(false);
  const [currentTab, setCurrentTab] = useState("Flow Details");
  const [generalCreated, setGeneralCreated] = useState(false);
  const [created,setCreated]=useState();
  const onSuccess = (data) => {
    setisLoading(false);
    successToast(data?.message||"Success");
    // if(data?.data?.approval_flow_id || formikRef.current.document_id){
      if(currentTab==="Flow Details"){
          setGeneralCreated(true);
          formikRef.current.setFieldValue("document_id",data?.data?.approval_flow_id);
          setCreated((prev) => new Set(prev).add("Flow Details"));
      }
      if(currentTab==="Originator"){
        const apiOriginators =data?.data||[];
        syncOriginatorIds(formikRef.current, apiOriginators);
        setCreated((prev) => new Set(prev).add("Originator"));
      }
      if(currentTab==="Documents & Terms"){
        setCreated((prev) => new Set(prev).add("Documents & Terms"));
      }
      if(currentTab==="Stages"){
        setCreated((prev) => new Set(prev).add("Stages"));
      }
      const i = itemTabs.indexOf(currentTab);
      const nextIdx = Math.min(i + 1, itemTabs.length - 1);
      setCurrentTab(itemTabs[nextIdx]);
    // }
  };
  const onError = (data) => {
    setisLoading(false);
    errorToast(data?.data?.message);
  };
  const onSubmit = (values, actions) => {
    if (currentTab === "Flow Details") {
      const data= { "description": values.description,"is_active":values.is_active,"name": values.flow_name };
      if(values.flow_name.trim()===''){
        errorToast("Please enter a valid name");
      }else{
          dispatch(
          addApprovalWorkFlowAction(
          data,
            onSuccess,
            onError
          )
        );
      }
    } else if (currentTab === "Originator") {
      if(values.document_id){
        const data = values.originators.map(item => ({
          ...(item?.originator_id ? { originator_id: item.originator_id } : {}),
          approval_flow_id: values.document_id,
          department: item.department,
          role: item.role,
          user_ids: item.users
        }));
        console.log(data);
        if(!(data[0].department && data[0].role && data[0].user_ids.length)){
          errorToast("Please add atleast one originator");
        }else{
          dispatch(
            addOriginatorsAction(
              data,
              onSuccess,
              onError
            )
          );
        }
      }else{
        errorToast("Something went wrong. Try again");
        navigate("/approval-work-flow/list");
      }
    } else if (currentTab === "Documents & Terms") {
      if(values.document_id){
        const conditions=values.conditions;
        const formattedConditions = conditions
        .filter(cond => cond.enabled)
        .map(({ field, aggregator, value }) => ({
          field,
          aggregator,
          value
        }));
        const data={
          document_category: values.documentCategory,
          approval_flow_id: values.document_id,
          document_types: [values.documentType],
          conditions:formattedConditions
        }
        if(values.documentCategory === '' || formattedConditions.length<=0){
          errorToast("Please select at one document")
        }
        else{
          dispatch(
            addDocumentsAction(
              data,
              onSuccess,
              onError
            )
          );
        }
        console.log(data);
      }
      else{
        errorToast("Something went wrong. Try again");
        navigate("/approval-work-flow/list");
      }
    } else if (currentTab === "Stages") {
      if(values.document_id){
        const stages=convertStagesData(values.approvalStages).stages
        const data={approval_flow_id: values.document_id,stages:stages};
        if(stages.length>0){
            dispatch(
              addStagesAction(
                data,
                onSuccess,
                onError
              )
          );
        }
        else{
          errorToast("Please add atleast one stage");
        }
        console.log(data);
        
      }
      else{
        errorToast("Something went wrong. Try again");
        navigate("/approval-work-flow/list");
      }
    } else if (currentTab === "Approval Path") {
      const stages=convertStagesData(values.approvalStages).stages;
      const Originatordata = values.originators.map(item => ({
          ...(item?.originator_id ? { originator_id: item.originator_id } : {}),
          approval_flow_id: values.document_id,
          department: item.department,
          role: item.role,
          user_ids: item.users
        }));
      const conditions=values.conditions;
        const formattedConditions = conditions
        .filter(cond => cond.enabled)
        .map(({ field, aggregator, value }) => ({
          field,
          aggregator,
          value
        }));
      if(!(Originatordata[0].department)){
          errorToast("Please add atleast one originator");
          setCurrentTab("Originator");
      }
      else if(stages.length<=0){
        errorToast("Please add atleast one stage");
        setCurrentTab("Stages");
      }else if(values.documentCategory === '' || formattedConditions.length<=0){
          errorToast("Please select at one document")
      }
      else{
          successToast("Approval Workflow created successfully");
          navigate("/approval-work-flow/list");
      }
    } else {
      console.log("not yet configured");
    }
  };

  return (
    <InnerLayout title="Create Approval Work Flow" backBtn={true}>
      <div className="px-5">
        <NavBar
          // generalCreated={generalCreated}
          generalCreated={generalCreated}
          tabs={itemTabs}
          currentTab={currentTab}
          setCurrentTab={setCurrentTab}
          isNotFirstTabAllowed={true}
        />

        <Formik
          enableReinitialize={true}
          onSubmit={onSubmit}
          initialValues={initialValues}
          validationSchema={validationSchema}
          innerRef={formikRef}  
        >
          {({ values, setFieldValue, handleSubmit, errors, resetForm }) => (
            <form
              onSubmit={handleSubmit}
              // 2-row grid: scrollable content + fixed footer
              className="grid grid-rows-[1fr,auto] min-h-[calc(100vh-140px)] overflow-hidden"
            >
              <LoadingOverlay isLoading={isLoading} />
              {/* Scrollable content area */}
              <div className="row-start-1 overflow-y-auto p-4 pr-2">
                {currentTab === "Flow Details" && <FlowDetails />}
                {currentTab === "Originator" && <Originator />}
                {currentTab === "Documents & Terms" && <DocumentSection />}
                {currentTab === "Stages" && <ApprovalStages />}
                {currentTab === "Approval Path" && <FlowPreview />}
              </div>

              {/* Fixed footer bar */}
              <div className="row-start-2 bg-background px-4 py-3 pb-[calc(env(safe-area-inset-bottom,0px)+12px)] mt-5">
                <div className="flex items-center justify-between gap-3">
                  <button
                    type="button"
                    onClick={() => resetForm()}
                    className="text-primary border border-primary px-4 py-2 rounded-md text-sm flex items-center gap-1 hover:bg-primary hover:text-white transition-all duration-300"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="bg-primary border border-primary text-white px-5 py-2 rounded-md text-sm flex items-center gap-1 hover:bg-white hover:text-primary transition-all duration-300"
                  >
                    Save
                  </button>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </InnerLayout>
  );
};

export default ApprovalWorkFlow;

const itemTabs = [
  "Flow Details",
  "Originator",
  "Documents & Terms",
  "Stages",
  "Approval Path",
];
